var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},[_c('li',[_c('p',[_vm._v("メンテナンス時間は目安なので設定通りにメンテナンスが開始、終了するということではありません。")])]),_c('li',[_c('p',[_vm._v("「内容」にはメンテナンス理由やリリース内容を記入してください。")])])])
}]

export { render, staticRenderFns }